<script>
export default {
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
  },
};
</script>

<template>
  <div class="empty-state flex flex-col items-center justify-center gap-3 py-12 px-4">
    <h3
      v-if="title"
      class="text-n-slate-12 block text-center w-full text-2xl font-extrabold"
    >
      {{ title }}
    </h3>
    <p
      v-if="message"
      class="block text-center text-n-slate-11 max-w-xl tracking-[0.3px]"
    >
      {{ message }}
    </p>
    <slot />
  </div>
</template>
